import { render, staticRenderFns } from "./dispatchOrder.vue?vue&type=template&id=0e03c4ac&"
import script from "./dispatchOrder.vue?vue&type=script&lang=js&"
export * from "./dispatchOrder.vue?vue&type=script&lang=js&"
import style0 from "./dispatchOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports